/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hour_Seemly_Mink_TickleInputs */

const fr_hour_seemly_mink_tickle = /** @type {(inputs: Hour_Seemly_Mink_TickleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réinitialisation du mot de passe`)
};

/**

* @param {Hour_Seemly_Mink_TickleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const hour_seemly_mink_tickle = /** @type {((inputs?: Hour_Seemly_Mink_TickleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hour_Seemly_Mink_TickleInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_hour_seemly_mink_tickle(inputs)
});